import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pstub_btn_arrow",
  "use": "icon-pstub_btn_arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pstub_btn_arrow\"><circle cx=\"12\" cy=\"12\" fill=\"#fff\" r=\"12\" /><path d=\"m9.999 18.484c-.191 0-.382-.072-.528-.218-.294-.291-.296-.767-.005-1.061l4.799-4.839-4.799-4.84c-.292-.294-.29-.769.005-1.061.293-.291.768-.289 1.061.005l5.088 5.132c.417.421.417 1.106.001 1.527l-5.089 5.133c-.148.148-.341.222-.533.222zm4.555-5.826h.01z\" fill=\"#999\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pstub_btn_arrow.svg
// module id = hpdV
// module chunks = 87